// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-btn.fab[data-v-2f84aed8]{\r\n    Z-index:95;\r\n  position: fixed;\r\n  right: 5px;\r\n  bottom: 70px;\r\n  background-color: #252DCF;\r\n  margin: 0 auto;\n}\n.v-alert[data-v-2f84aed8] {\r\n    Z-index:99;\r\n  position: fixed;\r\n  right: 10px;\r\n  bottom: 70px;\r\n  min-width:80%;\r\n  background-color: #252DCF;\r\n  margin: 0 auto;\n}\r\n", ""]);
// Exports
module.exports = exports;
